/**
 * Maison Montrose — recherches récentes.
 *
 * Le composant de recherche prédictive d'Horizon re-rend son état vide à
 * chaque effacement (il morphe la section `predictive-search-empty`). Nos
 * blocs reviennent donc dans le DOM sans prévenir : on observe le conteneur
 * plutôt que de peupler la liste une seule fois au chargement.
 *
 * Rien n'est envoyé nulle part : les termes restent dans le localStorage du
 * visiteur, et le bouton « Effacer » les efface vraiment.
 */

(function () {
  'use strict';

  var KEY = 'mm:search:recent';
  var MAX = 6;

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (t) { return typeof t === 'string'; }) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (error) {
      /* navigation privée */
    }
  }

  function remember(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = read().filter(function (item) {
      return item.toLowerCase() !== term.toLowerCase();
    });
    list.unshift(term);
    write(list);
  }

  function paint(group) {
    var list = group.querySelector('[data-mm-recent-list]');
    if (!list) return;
    var terms = read();

    group.hidden = terms.length === 0;
    if (!terms.length) {
      list.textContent = '';
      return;
    }

    list.textContent = '';
    terms.forEach(function (term) {
      var link = document.createElement('a');
      link.className = 'mon-search-suggest__chip';
      link.href = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
      link.textContent = term;
      list.appendChild(link);
    });
  }

  function paintAll() {
    document.querySelectorAll('[data-mm-recent-searches]').forEach(paint);
  }

  // À l'ouverture du modal, Horizon donne le focus au champ : c'est le
  // moment le plus fiable pour rafraîchir la liste, qui a pu bouger dans un
  // autre onglet depuis le chargement de la page.
  document.addEventListener('focusin', function (event) {
    if (event.target && event.target.name === 'q') paintAll();
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-mm-recent-clear]');
    if (!clear) return;
    event.preventDefault();
    write([]);
    paintAll();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"]');
    if (input) remember(input.value);
  });

  // Le clic sur un résultat prédictif ne passe pas par un submit : on capte
  // aussi la sortie du champ, c'est ce que le visiteur a réellement cherché.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.name === 'q') remember(input.value);
  });

  if (window.location.pathname.indexOf('/search') === 0) {
    var params = new URLSearchParams(window.location.search);
    remember(params.get('q') || '');
  }

  paintAll();

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var node = records[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches('[data-mm-recent-searches]') || node.querySelector('[data-mm-recent-searches]')) {
          paintAll();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
